import { Platform } from 'react-native';
import { File } from 'expo-file-system';

/**
 * Frees a recording or a voice clip nobody will read again: deletes the cache
 * file on native, revokes the blob URL on web. Best effort; a file that is
 * already gone is fine.
 */
export function discardVoiceFile(uri: string | null | undefined): void {
  if (!uri) return;
  try {
    if (Platform.OS === 'web') {
      if (uri.startsWith('blob:')) URL.revokeObjectURL(uri);
      return;
    }
    const file = new File(uri);
    if (file.exists) file.delete();
  } catch {
    // Already deleted, or the cache was cleared under us.
  }
}
